module.exports = __webpack_public_path__ + "img/6f0541b90aa0f9382dfee1e58d2064d3.png";